import React from 'react'
import { Input, Switch } from './common'

class EmailEditor extends React.Component {
	constructor(props) {
		super(props)
		this.has_changes = false
		this.onChange = this.onChange.bind(this)
		this.onBlur = this.onBlur.bind(this)
	}

	onChange(e) {
		this.has_changes = true
	}

	onBlur() {
		if (!this.has_changes) {
			return
		}
		const { cfg, accounts } = this.props
		this.has_changes = false
		cfg.value = JSON.stringify(accounts)
	}

	render() {
		const { account, accounts, cfg } = this.props

		return (
			<div className='widget-body'>
				{account._system == 1 ? null :
				 <Input model={account} name="name"
					label="Nome da conta"
					className="row form-group"
					classNameLabel="col-xs-12 col-sm-3"
					classNameControl="col-xs-12 col-sm-8"
					onChange={this.onChange}
					onBlur={this.onBlur}
				 />}
				<Input model={account} name="smtp_server"
					label="Servidor SMTP"
					className="row form-group"
					classNameLabel="col-xs-12 col-sm-3"
					classNameControl="col-xs-12 col-sm-8"
					onChange={this.onChange}
					onBlur={this.onBlur}
			/>
				<div className="row form-group">
					<label htmlFor="port" className="col-xs-12 col-md-3">Porta</label>
					<Input model={account} name="port" type="number"
						classNameControl="col-xs-12 col-sm-3"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
					<div className="col-xs-12 col-sm-4">
						<label className="radio-inline" htmlFor="ssh1">
							<input id="ssh1" type="radio" name="ssl" checked={account.ssl == 1 || account.ssl == 'ssl'}
								onChange={() => {
									account.ssl = 1
									cfg.value = JSON.stringify(accounts)
									this.forceUpdate()
								}}
							/>
							SSL/TLS
						</label>
						<label className="radio-inline" htmlFor="ssh2">
							<input id="ssh2" type="radio" name="ssl" checked={account.ssl == 0}
								onChange={() => {
									account.ssl = 0
									cfg.value = JSON.stringify(accounts)
									this.forceUpdate()
								}}
							/>
							Normal
						</label>
					</div>
				</div>
				<div className="row form-group">
					<label className="col-xs-12 col-md-3 radio-inline" htmlFor="smtp_auth">Autenticação SMTP</label>
					<div className="col-xs-12 col-md-8">
						<Switch model={account} name="smtp_auth" onChange={() => {
							cfg.value = JSON.stringify(accounts)
							this.forceUpdate()
						}} />
					</div>
				</div>
				<Input model={account} name="username"
					label="Utilizador"
					className="row form-group"
					classNameLabel="col-xs-12 col-sm-3"
					classNameControl="col-xs-12 col-sm-8"
					onChange={this.onChange}
					onBlur={this.onBlur}
			/>
				<Input model={account} name="password" type="password"
					label="Password"
					className="row form-group"
					classNameLabel="col-xs-12 col-sm-3"
					classNameControl="col-xs-12 col-sm-8"
					onChange={this.onChange}
					onBlur={this.onBlur}
			/>
				<div className="row form-group">
					<label htmlFor="from" className="col-xs-12 col-md-3">De</label>
					<Input model={account} name="from"
						classNameControl="col-xs-12 col-sm-3"
						placeholder="Email"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
					<Input model={account} name="from_name"
						classNameControl="col-xs-12 col-sm-4"
						placeholder="Nome"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
				</div>
				<div className="row form-group">
					<label htmlFor="reply" className="col-xs-12 col-md-3">Responder para</label>
					<Input model={account} name="reply" type="email"
						classNameControl="col-xs-12 col-sm-3"
						placeholder="Email"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
					<Input model={account} name="reply_name"
						classNameControl="col-xs-12 col-sm-4"
						placeholder="Nome"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
				</div>
				<div className="row form-group">
					<label htmlFor="inbox" className="col-xs-12 col-md-3">{__('buttons_inbox_text')}</label>
					<Input model={account} name="inbox" type="email"
						classNameControl="col-xs-12 col-sm-3"
						placeholder="Email"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
					<Input model={account} name="inbox_name"
						classNameControl="col-xs-12 col-sm-4"
						placeholder="Nome"
						onChange={this.onChange}
						onBlur={this.onBlur}
					/>
				</div>
			</div>
		)
	}
}

export default class EmailManager extends React.Component {
	constructor(props) {
		super(props)
		this.componentWillReceiveProps(props)
	}

	componentWillReceiveProps(props) {
		this.accounts = JSON.parse(props.cfg.value)
		this.accounts[0]._system = 1
	}

	render() {
		const { cfg } = this.props
		const accounts = []
		const alts = ['even', 'odd']

		this.accounts.forEach((account, i) => {
			const cls = alts[i % 2]

			accounts.push(
				<tr key={i} className={'pointer ' + cls} onClick={() => {
					account.expanded = account.expanded == 1 ? 0 : 1
					this.forceUpdate()
				}}>
					<td>{account.id || ''}</td>
					<td>{account.name}</td>
					<td>{account.username}</td>
					<td>{account.smtp_server}</td>
					<td>{account.ssl}</td>
					<td>{account.port}</td>
					<td>
						<div className="btn-group">
							<button className="btn btn-circular" title="Enviar email de teste" onClick={e => {
								e.stopPropagation()
								http.post('/humanportalconfigs/saveEmailAccount.json?test_mode=1', account)
							}}>
								<em className="fa fa-envelope" />
							</button>
							{account._system == 1 ? null :
								<button className="btn btn-circular" onClick={(e) => {
									e.stopPropagation()
									this.accounts.splice(i, 1)
									cfg.value = JSON.stringify(this.accounts)
									this.forceUpdate()
								}}>
									<em className="la la-trash" />
								</button>
							}
						</div>
					</td>
				</tr>
			)
			if (account.expanded) {
				accounts.push(
					<tr key={i + 'e'} className={cls}>
						<td />
						<td colSpan={6}><EmailEditor account={account} cfg={cfg} accounts={this.accounts} /></td>
					</tr>
				)
			}
		})
		return (
			<div>
				<table className="table">
					<thead>
						<tr>
							<th>#</th>
							<th className='left'>Nome</th>
							<th className='left'>Utilizador</th>
							<th className='left'>Servidor SMTP</th>
							<th className='left'>SSL</th>
							<th className='left'>Porta</th>
							<th>
								<button className="btn btn-circular" onClick={(e) => {
									e.stopPropagation()
									this.accounts.push({
										expanded: 1,
										port: 587,
										ssl: 1,
										smtp_auth: 1
									})
									this.forceUpdate()
								}}>
									<em className="la la-plus" />
								</button>
							</th>
						</tr>
					</thead>
					<tbody>
						{accounts}
					</tbody>
				</table>
			</div>
		)
	}
}